$(document).ready(function() {
  var glb = '';
   /* ------------ Color Variant Swatch  ----------- */
  $(document).on('click', '.ibat-prod-color-swatch-clck:not(.not-active)', function (e) {
      e.preventDefault();
      var promo_code_data = $('.htusb-ui-prod-boost-generic-pricing');
      let loc_url = window.location.pathname;
      // let product_id_color_swatch = $(this).children('.ib-data-color-patch').children('[data-product-id]').attr('data-product-id');
      let product_handle_color_swatch = $(this).children('.ib-data-color-patch').children('[data-product-handle]').attr('data-product-handle');
      // let product_title_color_swatch = $(this).children('.ib-data-color-patch').children('[data-product-title]').attr('data-product-title');
      // let product_color_color_swatch = $(this).children('.ib-data-color-patch').children('[ddata-product-color]').attr('data-product-color');
            //   Update product content with fetched data
            // This will create a new entry in the browser's history, without reloading
            var newURL = `https://bombayhairpro.com/products/${product_handle_color_swatch}`;
            if(loc_url.startsWith('/products')){
              window.history.pushState({path: newURL}, '', newURL);
            }
            $('.product__info-container, #breadcrumb, .ib-product-viewer, .for-sticky-cartbtn, .thumbnail-list, .shopify-payment-button').addClass("product-load");
            $( "#breadcrumb" ).load( `/products/${product_handle_color_swatch}` + " #breadcrumb", function() {
              $(this).children(':first').unwrap();
            });
            $( "#product-right" ).load( `/products/${product_handle_color_swatch}` + " #product-right", function() {
              $(this).children(':first').unwrap();
              // theme.Product(document.getElementById('product-description'));
              $('.ibat-background').before(promo_code_data.prop('outerHTML'));
              reinitializeScripts('//bombayhairpro.com/cdn/shop/t/21/assets/ib-product-redesign.js');
              reinitializeScripts('//bombayhairpro.com/cdn/shop/t/21/assets/ib-backorder-text.js');
            });
            $('.shopify-payment-button').load(`/products/${product_handle_color_swatch}` + " .shopify-payment-button", function() {
              $(this).children(':first').unwrap();
                    function reinitializeScripts(url) {
                        // Check for existing script with the same src
                        let existingScript = Array.from(document.querySelectorAll('script')).find(script => script.src.includes('spb.en.js'));
                        if (existingScript) {
                            existingScript.parentNode.removeChild(existingScript);
                        }
                        // Create and append a new script element
                        let newScript = document.createElement('script');
                        newScript.src = url;
                        document.head.appendChild(newScript);
                    }
                    
                    let date = new Date(); // Ensure `date` is defined
                    let formattedDate = `${date.getFullYear()}${(date.getMonth() + 1).toString().padStart(2, '0')}${date.getDate().toString().padStart(2, '0')}${date.getHours().toString().padStart(2, '0')}${date.getMinutes().toString().padStart(2, '0')}${date.getSeconds().toString().padStart(2, '0')}`;
                    let scriptUrl = 'https://bombayhairpro.com/cdn/shopifycloud/payment-sheet/assets/latest/spb.en.js';
                    let cacheBustedUrl = `${scriptUrl}?t=${formattedDate}`;
                    
                    reinitializeScripts(cacheBustedUrl);                    
             });
            $( ".product__media-wrapper" ).load( `/products/${product_handle_color_swatch}` + " .product__media-wrapper", function() {
              $(this).children(':first').unwrap();
              zoombox_reintialize();
              $('.ib-sh-page-padding').removeClass('temp-cart-button');
              function reinitializeScripts(url, callback) {
                  // Check for existing script with the same src
                  let existingScript = Array.from(document.querySelectorAll('script')).find(script => script.src.includes('ib-fancy-warrenty.js'));
                  if (existingScript) {
                      existingScript.parentNode.removeChild(existingScript);
                  }
                  // Create and append a new script element
                  let newScript = document.createElement('script');
                  newScript.src = url;
              
                  // Add an onload event listener to ensure the script has fully loaded before executing callback
                  newScript.onload = function() {
                      if (callback && typeof callback === 'function') {
                          callback();  // Ensure sticky button functionality is re-initialized
                      }
                  };
              
                  document.head.appendChild(newScript);
              }
              
              let date = new Date();
              let formattedDate = `${date.getFullYear()}${(date.getMonth() + 1).toString().padStart(2, '0')}${date.getDate().toString().padStart(2, '0')}${date.getHours().toString().padStart(2, '0')}${date.getMinutes().toString().padStart(2, '0')}${date.getSeconds().toString().padStart(2, '0')}`;
              let scriptUrl = 'https://bombayhairpro.com/cdn/shop/t/21/assets/ib-fancy-warrenty.js';
              let cacheBustedUrl = `${scriptUrl}?t=${formattedDate}`;
              
              // Reinitialize the script and reattach the sticky button logic
              reinitializeScripts(cacheBustedUrl, function() {
                  // Code to ensure sticky button re-initializes after script reload
                  window.dispatchEvent(new Event('DOMContentLoaded')); // Re-trigger the DOMContentLoaded event
              });
              
            });
            $( ".product__description" ).load( `/products/${product_handle_color_swatch}` + " .product__description", function() {
              $(this).children(':first').unwrap();
              let shogun_builder = $('#pop-one .shogun-root script[src="https://cdn.getshogun.com/c1a13dd52ce938030bd7204085ee1fb1/global-assets-ac636e211a9b275e86f34964ef981ba19a4f1fb8.js"]');
              if(shogun_builder){
                shogun_builder.remove();
                let shogun_script = $('<script>').attr('src', 'https://cdn.getshogun.com/c1a13dd52ce938030bd7204085ee1fb1/global-assets-ac636e211a9b275e86f34964ef981ba19a4f1fb8.js');
                 $('#pop-one .shogun-root').append(shogun_script);
              }
              deleteScripts('//bombayhairpro.com/apps/tabs/easytabs-1.0.0.min.js');
              easytabcatch();
              easytabcatchafterscript();
              reinitializeScripts('//bombayhairpro.com/cdn/shop/t/21/assets/ib-accordianfix.js');
            });
            $("#ib-toolbox-video").load(`/products/${product_handle_color_swatch}` + " #ib-toolbox-video", function () {
                  $(this).children(':first').unwrap();
            });
            $( "#ib-sh-prod-add-on" ).load( `/products/${product_handle_color_swatch}` + " #ib-sh-prod-add-on", function() {
               $(this).children(':first').unwrap();
            });
            $('[data-oke-reviews-product-id][data-oke-widget]').load(location.href + " [data-oke-reviews-product-id][data-oke-widget]", function() {
              $(this).children(':first').unwrap();
              reinitializeScripts('https://d3hw6dc1ow8pp2.cloudfront.net/reviews-widget-plus/js/okendo-reviews.js');
            });
            
            $('.ib-recommendations-section').load(location.href + " .ib-recommendations-section", function() {
              $(this).children(':first').unwrap();
              reinitializeScripts_for_recommended("//bombayhairpro.com/cdn/shop/t/21/compiled_assets/scripts.js");
              let date = new Date();
              let formattedDate = `${date.getFullYear()}${(date.getMonth() + 1).toString().padStart(2, '0')}${date.getDate().toString().padStart(2, '0')}${date.getHours().toString().padStart(2, '0')}${date.getMinutes().toString().padStart(2, '0')}${date.getSeconds().toString().padStart(2, '0')}`;
              let ib_slice_js_script = $('<script>').attr('src', `//bombayhairpro.com/cdn/shop/t/21/assets/ib-slice.js?${formattedDate}`);           
               $('.ib-recommendations-section').append(ib_slice_js_script);
              slider_reintialize();
             
            });
    });
  /*    ------------  Color Swatch end  ------------   */
  
  /* ------------ Length Variant Swatch  ----------- */
  
  $(document).on('click', '.ibat-prod-length-swatch-clck:not(.not-active)', function (e) {
      e.preventDefault();
      var promo_code_data_length = $('.htusb-ui-prod-boost-generic-pricing');
      let loc_url = window.location.pathname;
      // let product_id_length_swatch = $(this).children('.ib-data-length-variant').children('[data-product-id]').attr('data-product-id');
      let product_handle_length_swatch = $(this).children('.ib-data-length-variant').children('[data-product-handle]').attr('data-product-handle');
      // let product_title_length_swatch = $(this).children('.ib-data-length-variant').children('[data-product-title]').attr('data-product-title');
      // let product_color_length_swatch = $(this).children('.ib-data-length-variant').children('[data-product-color]').attr('data-product-color');
            //   Update product content with fetched data
            // This will create a new entry in the browser's history, without reloading
            var newURL = `https://bombayhairpro.com/products/${product_handle_length_swatch}`;
            if(loc_url.startsWith('/products')){
              window.history.pushState({path: newURL}, '', newURL);
            }
            $('.product__info-container, #breadcrumb, .for-sticky-cartbtn, .ib-product-viewer, .thumbnail-list, .shopify-payment-button').addClass("product-load");
            $( "#breadcrumb" ).load( `/products/${product_handle_length_swatch}` + " #breadcrumb", function() {
              $(this).children(':first').unwrap();
            });
            $( "#product-right" ).load( `/products/${product_handle_length_swatch}` + " #product-right", function() {
              $(this).children(':first').unwrap();
              // theme.Product(document.getElementById('product-description'));
              $('.ibat-background').before(promo_code_data_length.prop('outerHTML'));
              reinitializeScripts('//bombayhairpro.com/cdn/shop/t/21/assets/ib-product-redesign.js');
              reinitializeScripts('//bombayhairpro.com/cdn/shop/t/21/assets/ib-backorder-text.js'); 
            });
            $('.shopify-payment-button').load(`/products/${product_handle_length_swatch}` + " .shopify-payment-button", function() {
              $(this).children(':first').unwrap();
              function reinitializeScripts(url) {
                        // Check for existing script with the same src
                        let existingScript = Array.from(document.querySelectorAll('script')).find(script => script.src.includes('spb.en.js'));
                        if (existingScript) {
                            existingScript.parentNode.removeChild(existingScript);
                        }
                        // Create and append a new script element
                        let newScript = document.createElement('script');
                        newScript.src = url;
                        document.head.appendChild(newScript);
                    }
                    
                    let date = new Date(); // Ensure `date` is defined
                    let formattedDate = `${date.getFullYear()}${(date.getMonth() + 1).toString().padStart(2, '0')}${date.getDate().toString().padStart(2, '0')}${date.getHours().toString().padStart(2, '0')}${date.getMinutes().toString().padStart(2, '0')}${date.getSeconds().toString().padStart(2, '0')}`;
                    let scriptUrl = 'https://bombayhairpro.com/cdn/shopifycloud/payment-sheet/assets/latest/spb.en.js';
                    let cacheBustedUrl = `${scriptUrl}?t=${formattedDate}`;
                    
                    reinitializeScripts(cacheBustedUrl);
            });
            $( ".product__media-wrapper" ).load( `/products/${product_handle_length_swatch}` + " .product__media-wrapper", function() {
              $(this).children(':first').unwrap();
              zoombox_reintialize();
              $('.ib-sh-page-padding').removeClass('temp-cart-button');
              function reinitializeScripts(url, callback) {
                  // Check for existing script with the same src
                  let existingScript = Array.from(document.querySelectorAll('script')).find(script => script.src.includes('ib-fancy-warrenty.js'));
                  if (existingScript) {
                      existingScript.parentNode.removeChild(existingScript);
                  }
                  // Create and append a new script element
                  let newScript = document.createElement('script');
                  newScript.src = url;
              
                  // Add an onload event listener to ensure the script has fully loaded before executing callback
                  newScript.onload = function() {
                      if (callback && typeof callback === 'function') {
                          callback();  // Ensure sticky button functionality is re-initialized
                      }
                  };
              
                  document.head.appendChild(newScript);
              }
              
              let date = new Date();
              let formattedDate = `${date.getFullYear()}${(date.getMonth() + 1).toString().padStart(2, '0')}${date.getDate().toString().padStart(2, '0')}${date.getHours().toString().padStart(2, '0')}${date.getMinutes().toString().padStart(2, '0')}${date.getSeconds().toString().padStart(2, '0')}`;
              let scriptUrl = 'https://bombayhairpro.com/cdn/shop/t/21/assets/ib-fancy-warrenty.js';
              let cacheBustedUrl = `${scriptUrl}?t=${formattedDate}`;
              
              // Reinitialize the script and reattach the sticky button logic
              reinitializeScripts(cacheBustedUrl, function() {
                  // Code to ensure sticky button re-initializes after script reload
                  window.dispatchEvent(new Event('DOMContentLoaded')); // Re-trigger the DOMContentLoaded event
              });
            });
            $( ".product__description" ).load( `/products/${product_handle_length_swatch}` + " .product__description", function() {
              $(this).children(':first').unwrap();
              let shogun_builder = $('#pop-one .shogun-root script[src="https://cdn.getshogun.com/c1a13dd52ce938030bd7204085ee1fb1/global-assets-ac636e211a9b275e86f34964ef981ba19a4f1fb8.js"]');
              if(shogun_builder){
                shogun_builder.remove();
                let shogun_script = $('<script>').attr('src', 'https://cdn.getshogun.com/c1a13dd52ce938030bd7204085ee1fb1/global-assets-ac636e211a9b275e86f34964ef981ba19a4f1fb8.js');
                 $('#pop-one .shogun-root').append(shogun_script);
              }
              deleteScripts('//bombayhairpro.com/apps/tabs/easytabs-1.0.0.min.js');
              easytabcatch();
              easytabcatchafterscript();
              reinitializeScripts('//bombayhairpro.com/cdn/shop/t/21/assets/ib-accordianfix.js');
            });
            $("#ib-toolbox-video").load(`/products/${product_handle_length_swatch}` + " #ib-toolbox-video", function () {
                  $(this).children(':first').unwrap();
            });
            $( "#ib-sh-prod-add-on" ).load( `/products/${product_handle_length_swatch}` + " #ib-sh-prod-add-on", function() {
              $(this).children(':first').unwrap();
            });
            $('[data-oke-reviews-product-id][data-oke-widget]').load(location.href + " [data-oke-reviews-product-id][data-oke-widget]", function() {
              $(this).children(':first').unwrap();
              reinitializeScripts('https://d3hw6dc1ow8pp2.cloudfront.net/reviews-widget-plus/js/okendo-reviews.js');
            });
            $('.ib-recommendations-section').load(location.href + " .ib-recommendations-section", function() {
              $(this).children(':first').unwrap();
              reinitializeScripts_for_recommended("//bombayhairpro.com/cdn/shop/t/21/compiled_assets/scripts.js");
              let date = new Date();
              let formattedDate = `${date.getFullYear()}${(date.getMonth() + 1).toString().padStart(2, '0')}${date.getDate().toString().padStart(2, '0')}${date.getHours().toString().padStart(2, '0')}${date.getMinutes().toString().padStart(2, '0')}${date.getSeconds().toString().padStart(2, '0')}`;
              let ib_slice_js_script = $('<script>').attr('src', `//bombayhairpro.com/cdn/shop/t/21/assets/ib-slice.js?${formattedDate}`);           
               $('.ib-recommendations-section').append(ib_slice_js_script);
              slider_reintialize();
              
            });
    });
  /*  ------------   Length Swatch end  ------------  */
  
      function reinitializeScripts_for_recommended(srcStartsWith) {
          // Regular expression pattern to match the src attribute starting with the specified string
          var regex = new RegExp('^' + srcStartsWith.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
          // Loop through all script elements
          $('script').each(function() {
              var scriptSrc = $(this).attr('src');
              var scriptid = $(this).attr('id');
              var scriptdata_sections = $(this).attr('data-sections');
              // Check if the script's src attribute starts with the specified string
              if (scriptSrc && regex.test(scriptSrc)) {
                  // Reinitialize the script by removing and reappending it to its parent node
                  var parent = this.parentNode;
                  this.remove();
                  var newScript = document.createElement('script');
                  if(scriptid){ 
                  newScript.id = scriptid;
                  }
                  if(scriptdata_sections){ 
                  newScript.setAttribute('data-sections', scriptdata_sections);
                  }
                  newScript.src = scriptSrc;
                  parent.appendChild(newScript);
              }
          });
      }
  
      


       function zoombox_reintialize(){
        const zoomBox = $('.ib-prod-zoom-box');

        const setBackgroundImage = (src) => {
            zoomBox.css('background-image', `url(${src})`);
        };
    
        const updateBackgroundPosition = (event) => {
            const { offsetX, offsetY, target } = event;
            const { offsetWidth: width, offsetHeight: height } = target;
    
            const xPos = (offsetX / width) * 100;
            const yPos = (offsetY / height) * 100;
    
            zoomBox.css('background-position', `${xPos}% ${yPos}%`);
        };
    
        const clearBackgroundImage = () => {
            zoomBox.css('background-image', '');
            zoomBox.css('background-position', '');
        };
    
        $('.ib-prod-gallery-main').on({
            mouseenter: function (event) {
                const img = $(this).find('.product__media img');
                setBackgroundImage(img.attr('src'));
                zoomBox.css('display', 'block');
            },
            mousemove: function (event) {
                updateBackgroundPosition(event);
            },
            mouseleave: function () {
                clearBackgroundImage();
                zoomBox.css('display', 'none');
            }
        }, 'li.is-active');
      }
  
      function slider_reintialize() {
    var sliderInitialized = false;

    function initializeSlider() {
        if (!sliderInitialized && $(window).width() <= 980) {
            $('.ib-slider').slick({
                dots: false,
                infinite: true,
                speed: 300,
                slidesToShow: 2,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
            });
            sliderInitialized = true;
        }
    }

    function unslickSlider() {
        if (sliderInitialized && $(window).width() > 980) {
            $('.ib-slider').slick('unslick');
            sliderInitialized = false;
        }
    }

    if ($('.ib-custom .product').length !== 0) {
        initializeSlider();
        unslickSlider();
    }

    // Use MutationObserver to monitor changes to the .ib-custom element
    var observer = new MutationObserver(function (mutationsList, observer) {
        for (var mutation of mutationsList) {
            if (mutation.type === 'childList') {
                setTimeout(function () {
                    initializeSlider();
                    unslickSlider();
                }, 1000);
                break;
            }
        }
    });

    // Configure the observer to look for child nodes being added or removed
    observer.observe(document.querySelector('.ib-custom'), {
        childList: true,
        subtree: true
    });

    // Check on window resize
    $(window).resize(function () {
        unslickSlider();
    });
}

  
      function reinitializeScripts(srcStartsWith) {
            // Escape special characters in the string
            var escapedSrcStartsWith = srcStartsWith.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            var regex = new RegExp('^' + escapedSrcStartsWith);
        
            // Get all script elements on the page
            var scripts = [...document.querySelectorAll('script')];
            scripts.forEach(function(script) {
                var scriptSrc = script.getAttribute('src');
                var scriptId = script.getAttribute('id');
                
                // Check if the script's src attribute starts with the specified string
               if (scriptSrc && regex.test(scriptSrc)) {
                    // Clone the script element to reinitialize it
                    var newScript = document.createElement('script');
                   newScript.src = scriptSrc;
                    if (scriptId) {
                        newScript.id = scriptId;
                    }
        
                    // Remove the old script and append the new one
                    script.parentNode.replaceChild(newScript, script);
                }
            });
        }
  
      function deleteScripts(srcStartsWith) {
          // Regular expression pattern to match the src attribute starting with the specified string
          var regex = new RegExp('^' + srcStartsWith.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
          // Loop through all script elements
          $('script').each(function() {
              var scriptSrc = $(this).attr('src');
              var scriptid = $(this).attr('id');
              // Check if the script's src attribute starts with the specified string
              if (scriptSrc && regex.test(scriptSrc)) {
                  this.remove();
              }
          });
      }
  
      function easytabcatch(){
        if(window.easytabsOnError||(window.easytabsOnError=function(){let e=document.querySelectorAll(".easytabs-hidden");for(let t=e.length-1;t>=0;t--)e[t]&&e[t].classList.remove("easytabs-hidden");let t=document.querySelectorAll(".easytabs-tabs, .easytabs-content-item-static, .easytabs-undertabs-holder, .easytabs-styles, .easytabs-default-accordion-item");for(let e=t.length-1;e>=0;e--)t[e]&&t[e].remove();let a=document.querySelectorAll(".easytabs-container");for(let e=a.length-1;e>=0;e--){if(!a[e])continue;let t=a[e].querySelectorAll("div.easytabs-content-item"),n="";for(let e=t.length-1;e>=0;e--){if(!t[e])continue;let a=t[e].querySelector("div.easytabs-accordion-item");if(a){let e=a.querySelector(".easytabs-header-text");e&&(n+="<h2>"+e.innerHTML+"</h2>")}var s=t[e].querySelector("div.easytabs-content-holder");s&&(n+=s.innerHTML)}a[e].insertAdjacentHTML("afterend",n),a[e].remove()}}),"error"===window.easytabsScriptStatus)window.easytabsOnError();else if(!document.querySelector("head #easytabs-head-script")){let e=document.createElement("script");e.id="easytabs-head-script",e.async=!0,e.setAttribute("data-no-instant",""),e.src='//bombayhairpro.com/apps/tabs/easytabs-1.0.0.min.js?'+(new Date).getHours()+(new Date).getMinutes(),e.onload=function(){"object"==typeof easytabs?(window.easytabsScriptStatus="loaded",easytabs.initWidgets(document.querySelectorAll(".easytabs-hidden")),easytabs.initPage()):(window.easytabsScriptStatus="error",window.easytabsOnError())},e.onerror=function(){window.easytabsScriptStatus="error",window.easytabsOnError()},document.getElementsByTagName("head")[0].appendChild(e)}
      }
  
      function easytabcatchafterscript(){
        if( typeof easytabs == 'object' ) { easytabs.initWidgets(document.querySelectorAll('.tab-widget-')); }
      }
  
});